import
  React
from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  CustomColors
} from '../../constants';

const Overlay = styled.div`
  z-index: 4;
  background-color: ${props => props.backgroundColor};
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
`;

export const Modal = props => {

  React.useEffect(() => {

    document.body.style.overflow = 'hidden';
    return ()=> document.body.style.overflow = 'scroll';
 }, []);

  return (

    <Overlay
      onClick={props.onClose}
      backgroundColor={props.backgroundColor}>

      {props.children}
    </Overlay>
  );
};

Modal.propTypes = {
  onClose: PropTypes.func,
  backgroundColor: PropTypes.string
};

Modal.defaultProps = {
  onClose: () => {},
  backgroundColor: CustomColors.TransparentBlack2
};
